import React, {useEffect} from 'react';
import {AppContext} from "./app-context";

const EMPTY_ARRAY = [];
export const APP_TITLE = "Picking";
export const HELP_TITLE = "Help Center";
export const HEADER_BACKGROUND_DARK = "#191919";
export const HEADER_BACKGROUND_ERROR = "#B21A36";
const APP_TOAST_TYPES = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
    INFORMATIVE: 'informative'
};
const ALERT_STATE_DEFAULT = {
    show: false,
    type: "success",
    message: "success"
};

/**
 * The function assists on the basic context and actions required by a component aka page
 * @param appOptions {{title: string, onBackPressed: function}}
 * @param helpOptions {{title: string, pageTitle: string, list: [{title: string, onClick: function}] }}
 * @returns {{isLoaderVisible: boolean, appState, hideLoader: function, appActions, toastActions, showLoader: function}}
 * @constructor
 */

export function UseAppContext(appOptions, helpOptions) {

    /**
     * Gather parent contexts
     */
    const {appState, appActions} = React.useContext(AppContext);

    /**
     * Create state and function for loader component
     */
    const [isLoaderVisible, setLoaderVisible] = React.useState(false);
    const showLoader = () => setLoaderVisible(true);
    const hideLoader = () => setLoaderVisible(false);

    /**
     * Create state and function for alert component
     */
    const [alertState, setAlertState] = React.useState(ALERT_STATE_DEFAULT);
    const successAlert = (message) => {
        appActions.setHeaderBackground(HEADER_BACKGROUND_DARK);
        setAlertState({
            show: true,
            type: APP_TOAST_TYPES.SUCCESS,
            message: message
        });
    };
    const errorAlert = (message) => {
        appActions.setHeaderBackground(HEADER_BACKGROUND_ERROR);
        setAlertState({
            show: true,
            type: APP_TOAST_TYPES.ERROR,
            message: message
        });
    };
    const warningAlert = (message) => {
        appActions.setHeaderBackground(HEADER_BACKGROUND_DARK);
        setAlertState({
            show: true,
            type: APP_TOAST_TYPES.WARNING,
            message: message
        });
    };
    const removeAlert = () => {
        appActions.setHeaderBackground(HEADER_BACKGROUND_DARK);
        setAlertState(ALERT_STATE_DEFAULT)
    };


    /**
     * Set the application state with help of useEffect, this will act as ComponentDidMount
     */
    if (appOptions) {
        useEffect(() => {
            appActions.setupHeader(appOptions.title || APP_TITLE, appOptions.onBackPressed);
        }, EMPTY_ARRAY);
    } else {
        // title as APP_TITLE, backEnabled to go back to previous page
        useEffect(() => {
            appActions.setupHeader(APP_TITLE, null);
            appActions.setHeaderBackground(HEADER_BACKGROUND_DARK);
        }, EMPTY_ARRAY);
    }

    if (helpOptions) {
        useEffect(() => {
            appActions.setupHelp(true, {
                title: helpOptions.title || HELP_TITLE,
                pageTitle: helpOptions.pageTitle,
                list: helpOptions.list
            });
        }, EMPTY_ARRAY);
    } else {
        // default behaviour: no help button
        useEffect(() => {
            appActions.setupHelp(false, {title: HELP_TITLE})
        }, EMPTY_ARRAY);
    }

    return {
        appState,
        appActions,
        alertState,
        alertActions: {successAlert, warningAlert, errorAlert, removeAlert},
        isLoaderVisible,
        showLoader,
        hideLoader
    };
}



// WEBPACK FOOTER //
// ./src/context/use-app-context.js